// src/components/tiptap/InternalNoteViewer.js
import React from "react";

export default function InternalNoteViewer({ value }) {
  if (!value) {
    return (
      <div className="text-sm text-slate-500 italic">
        No notes yet.
      </div>
    );
  }

  // ------------------------------------------------------------
  // TipTap JSON renderer (lightweight, read-only)
  // ------------------------------------------------------------

  if (typeof value === "object") {
    const renderNode = (node, key) => {
      if (!node) return null;

      // Plain text
      if (node.type === "text") {
        return node.text;
      }

      // Hard line break
      if (node.type === "hardBreak") {
        return <br key={key} />;
      }

      // Mention node
      if (node.type === "mention") {
        const attrs = node.attrs || {};
        const label = attrs.label || attrs.name || attrs.id || "";
        return (
          <span key={key} className="text-blue-600 font-medium">
            @{label}
          </span>
        );
      }

      // Paragraph
      if (node.type === "paragraph") {
        return (
          <p key={key} className="mb-2 last:mb-0">
            {Array.isArray(node.content)
              ? node.content.map(renderNode)
              : null}
          </p>
        );
      }

      // Generic container
      if (Array.isArray(node.content)) {
        return node.content.map(renderNode);
      }

      return null;
    };

    return (
      <div className="text-sm">
        {Array.isArray(value.content) && value.content.length > 0
          ? value.content.map(renderNode)
          : <span className="italic text-slate-500">No content</span>}
      </div>
    );
  }

    return (
      <div className="text-sm italic text-slate-500">
        Unsupported message format
      </div>
    );
}